import { createFileRoute } from '@tanstack/react-router';

import privacyPolicyHtml from '#features/static-pages/assets/privacy-policy.html?raw';
import privacyPolicyRuHtml from '#features/static-pages/assets/privacy-policy.ru.html?raw';
import { EmbeddedHtmlPage } from '#features/static-pages/components/EmbeddedHtmlPage';
import { legalPageOverrides } from '#features/static-pages/constants/legalPageOverrides';
import { staticPageHead } from '#features/static-pages/utils/head';
import { withLegalEnhancements } from '#features/static-pages/utils/legalEnhancements';

const title = 'Privacy Policy | Teamplay.gg';
const description = 'Read the Privacy Policy of Teamplay.gg.';

export const Route = createFileRoute('/{-$locale}/_layout/privacy-policy')({
  component: PrivacyPolicyPage,
  head: ({ params }) =>
    staticPageHead({
      title,
      description,
      pathname: '/privacy-policy',
      locale: params.locale,
      withRuLocale: true,
    }),
});

function PrivacyPolicyPage() {
  const { locale } = Route.useParams();
  const localePrefix = locale === 'ru' ? '/ru' : '';
  const html = locale === 'ru' ? privacyPolicyRuHtml : privacyPolicyHtml;
  const enhancedHtml = withLegalEnhancements(html, {
    fallbackUpdatedAt: 'Published on Teamplay.gg',
    quickLinks: [
      { href: `${localePrefix}/privacy-policy`, label: 'Privacy Policy' },
      { href: `${localePrefix}/terms-and-conditions`, label: 'Terms' },
      { href: `${localePrefix}/cookie-policy`, label: 'Cookie Policy' },
    ],
    tocTitle: locale === 'ru' ? 'Разделы' : 'On this page',
  });

  return (
    <EmbeddedHtmlPage
      html={enhancedHtml}
      title="Privacy Policy"
      minHeight={1100}
      extraStyles={legalPageOverrides}
      runInlineScripts
      shellWidth="980px"
      showReadingProgress
      showBackToTop
      enableSectionAnchors
    />
  );
}
